





























































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { deepClone, filterFlightsByTime, extractTime } from '@/utils'
import FlightService from '@/services/FlightService'
import SummaryTile from '@/components/SummaryTile.vue'
import AirportAutosuggest from '@/components/AirportAutosuggest.vue'
import AirlineAutosuggest from '@/components/AirlineAutosuggest.vue'
import Datepicker from '@/components/Datepicker.vue'
import FlightStatusPicker from '@/components/FlightStatusPicker.vue'
import DayRangeToggler from '@/components/DayRangeToggler.vue'
import InfoBox from '@/components/InfoBox.vue'
import RadioList from '@/components/RadioList.vue'
import Timepicker from '@/components/Timepicker.vue'
import Toggler from '@/components/Toggler.vue'
import ManualFlightNumber from '@/components/ManualFlightNumber.vue'
import IAirport from '@/store/interface/IAirport'
import IRoute from '@/store/interface/IRoute'
import { IFlight } from '@/store/interface/IFlight'
import { IListItem } from '@/store/interface/IListItem'
import IToggleOption from '@/store/interface/IToggleOption'
import DayPeriods from '@/store/data/enums/DayPeriods'
import FlightStatus from '@/store/data/enums/FlightStatuses'
import sameAndNextDayOptions from '@/store/data/sameAndNextDayOptions'
import { mapActions, mapGetters } from 'vuex'
import { date } from 'quasar'

@Component({
	name: 'FlightForm',
	components: {
		SummaryTile,
		AirportAutosuggest,
		AirlineAutosuggest,
		Datepicker,
		FlightStatusPicker,
		DayRangeToggler,
		InfoBox,
		RadioList,
		Timepicker,
		Toggler,
		ManualFlightNumber
	},
	validations: {
		flights: {
			$each: {}
		}
	},
	methods: {
		...mapGetters({
			currentStatus: 'communicationStatus/getStatus'
		}),
		...mapActions({
			setStatus: 'communicationStatus/setStatus'
		})
	}
})
export default class FlightForm extends Vue {
	@Prop()
	private flightsData!: IRoute[]
	@Prop({ default: false })
	private isAdditionalFlight!: boolean
	@Prop({ default: false })
	private shiftOrder!: boolean
	@Prop({ default: false })
	private isCompleted!: boolean
	@Prop({ default: false })
	private isReturnFlight!: boolean
	@Prop({ default: false })
	private shiftDateValidation!: boolean | undefined
	@Prop({ default: undefined })
	private prevTime!: string | undefined
	@Prop({ default: undefined })
	private prevDate!: string | undefined
	private setStatus!: Function
	private currentStatus!: Function
	private flights: IRoute[] = []
	private flightList: IFlight[] = []
	private flightListData: IListItem[] = []
	private selectedDayPeriodOption: string = ''
	private selectedFlightNumber: string = ''
	private isManualFlight: boolean = false
	private prevDateDoesMatch: boolean = false
	private isPageValid: boolean = false
	private isFormValid: boolean = false
	private isSameDay: boolean = true
	private disableSameDayToggler: boolean = false
	private sameAndNextDayOptionsList: IToggleOption[] = sameAndNextDayOptions
	private emptyFlight: IRoute = {
		depAirport: {
			iata: '',
			name: '',
			isValid: false
		},
		arrAirport: {
			iata: '',
			name: '',
			isValid: false
		},
		airline: {
			airlineCode: '',
			airlineName: ''
		},
		date: '',
		flightStatus: '',
		timeRange: '',
		isSameDay: true,
		arrivalTime: '',
		departureTime: '',
		manualFlightNumber: '',
		selectedFlightNumber: ''
	}

	beforeMount () {
		this.flights = deepClone<IRoute[]>(this.flightsData)
	}

	mounted () {
		/**
		 * Set component properties ta manipulate the active flight form properly
		 * as there can be only one active flight form
		 */
		const index: number = this.flights.length - 1
		const currentFlight: IRoute = this.flights[index]
		const { timeRange, selectedFlightNumber, isSameDay } = currentFlight
		this.selectedDayPeriodOption = timeRange
		this.selectedFlightNumber = selectedFlightNumber
		this.isSameDay = isSameDay!
		/**
		 * Prefilled page should make a call for last route, to show flight list
		 * with relevant flights in it
		 */
		this.onDayPeriodToggleChange(this.selectedDayPeriodOption, false)

		if (selectedFlightNumber === FlightStatus.unknown) {
			this.isManualFlight = true
			this.selectedFlightNumber = FlightStatus.unknown
		}
	}

	private get getPrevDate (): string | undefined {
		if (this.flights.length > 1) {
			const prevFlight: IRoute = this.flights[this.flights.length - 2]
			const formattedDate: string = `${prevFlight.date.convertDateToISOStandart()}T00:00:00`
			const nextDayDate: string = date.addToDate(new Date(formattedDate), { days: 1 }).toLocaleDateString().convertDateToRenderStandart().slice(0, 10)
			return prevFlight.isSameDay ? prevFlight.date : nextDayDate
		} else if (this.isAdditionalFlight) {
			return this.prevDate!
		}
	}

	private get getPrevTime (): string | undefined {
		if (this.flights.length > 1) {
			const prevFlight: IRoute = this.flights[this.flights.length - 2]
			return prevFlight.arrivalTime
		} else {
			return this.prevTime
		}
	}

	private get getProperDepartureTime (): string {
		const currentFlight: IRoute = this.flights[this.flights.length - 1]
		const { departureTime } = currentFlight
		const formattedDate: string = currentFlight.date.convertDateToISOStandart()

		if (typeof departureTime !== 'undefined' && departureTime.length === 5) {
			// Safari and Chrome couting local time differently, this is why we add Z and parse the date
			const currentDate: Date = new Date(Date.parse(`${formattedDate}T${departureTime}:00Z`))
			const newDate: Date = date.addToDate(currentDate, { minutes: 9 })
			const timeFormatOptions: any = {
				hour: '2-digit',
				minute: '2-digit',
				hour12: false,
				// mandatory field value to retrieve proper date for both safati and chrome
				timeZone: 'UTC'
			}
			const relevantComparisonTime: string = newDate.toLocaleTimeString([], timeFormatOptions)

			if (this.$refs.arrivalTime && typeof this.$refs.arrivalTime[0] !== 'undefined') {
				this.$refs.arrivalTime[0].$refs.time.validate()
			}

			return relevantComparisonTime
		} else {
			return ''
		}
	}

	private get getFlightTimeDifference (): boolean {
		const currentFlight: IRoute = this.flights[this.flights.length - 1]
		const { departureTime, arrivalTime, isSameDay } = currentFlight
		const formattedDate: string = currentFlight.date.convertDateToISOStandart()
		const nextDayFormattedDate: string = new Date(date.addToDate(formattedDate, { days: 1 })).extractDate()
		const depTimeIsValid: boolean = typeof departureTime !== 'undefined' && departureTime.length === 5
		const arrTimeIsValid: boolean = typeof arrivalTime !== 'undefined' && arrivalTime.length === 5

		if (depTimeIsValid && arrTimeIsValid) {
			const currentDepartureDate: Date = new Date(`${formattedDate}T${departureTime}:00`)
			const currentArrivalDate: Date = isSameDay ? new Date(`${formattedDate}T${arrivalTime}:00`) : new Date(`${nextDayFormattedDate}T${arrivalTime}:00`)
			const halfHourRangeDate: Date = date.addToDate(currentDepartureDate, { minutes: 10 })
			return date.isBetweenDates(currentArrivalDate, currentDepartureDate, halfHourRangeDate)
		} else {
			return false
		}
	}

	/**
	 * Additional callback to implement the specific custom  validation of the
	 * departure and arrival airport fields. It checks if the IATA codes are
	 * matching with each other and fires a validation error if the airports are
	 * the same
	 *
	 * @param val				- value itselt. when the field is cleared it can be null
	 * @param	refName		- reference name to set the value in the main array by the key
	 */
	private onAirportUpdate (val: IAirport | null, refName: string): void {
		const index: number = this.flights.length - 1
		this.flights[index][refName] = val

		if (val) {
			const depIata: boolean | string = !!this.flights[index].depAirport && this.flights[index].depAirport.iata
			const arrIata: boolean | string = !!this.flights[index].arrAirport && this.flights[index].arrAirport.iata

			// set additional param to prevent Vuelidate module from failing
			val.isValid = true

			// validate only when both airports are chosen
			if (depIata && arrIata) {
				const flightsAreValid: boolean = this.flights[index].depAirport.iata !== this.flights[index].arrAirport.iata

				this.flights[index].depAirport.isValid = flightsAreValid
				this.flights[index].arrAirport.isValid = flightsAreValid

				// validating the airport inputs separately to fire an error when airports are invalid
				if (this.$refs.depAirport && typeof this.$refs.depAirport[0] !== 'undefined') {
					this.$refs.depAirport[0].$refs.airport.validate()
				}
				if (this.$refs.arrAirport && typeof this.$refs.arrAirport[0] !== 'undefined') {
					this.$refs.arrAirport[0].$refs.airport.validate()
				}
			}
		}

		this.resetFlightList()
		this.validatePage()
	}

	// Applied to datepicker and airline to reset the flights list and do the validation afterwards
	private updateOfSensitiveFlightData () {
		this.resetFlightList()
		this.validatePage()
	}

	/**
	 * Toggler callback, that invokes the flight service to retrieve the flight
	 * list from the server. It has an optional argument - for sake of keeping the
	 * selectedFlightNumber in case when we have the stored and valid data taken
	 * from vuex module
	 */
	private onDayPeriodToggleChange (val: string, needsReset: boolean = true): void {
		this.selectedDayPeriodOption = val
		this.isManualFlight = false

		if (needsReset) {
			this.selectedFlightNumber = ''
			this.isSameDay = true
		}

		this.getFlightList()
			.then(() => {
				this.validatePage()
			})
			.catch((e: any) => console.error(e))
	}

	private onDepTimeChange (time: string): void {
		const currentFlight: IRoute = this.flights[this.flights.length - 1]
		const timeIsValid: boolean = time.length === 5
		this.disableSameDayToggler = false

		if (timeIsValid) {
			if (time.indexOf('23:5') === 0) {
				this.disableSameDayToggler = true
				this.isSameDay = false
			}

			if (time.indexOf('00:00') === 0) {
				this.disableSameDayToggler = true
				this.isSameDay = true
			}

			if (this.$refs.arrivalTime && typeof this.$refs.arrivalTime[0] !== 'undefined') {
				this.$refs.arrivalTime[0].$refs.time.validate()
			}

			currentFlight.isSameDay = this.isSameDay
			this.validatePage()
		}
	}

	private onSameDayTogglerChange (isSameDay: boolean): void {
		const currentFlight = this.flights[this.flights.length - 1]
		this.isSameDay = isSameDay
		currentFlight.isSameDay = isSameDay

		if (this.$refs.arrivalTime && typeof this.$refs.arrivalTime[0] !== 'undefined') {
			this.$refs.arrivalTime[0].modelData = ''
		}
	}

	private updateFlight (flight: IListItem): void {
		this.selectedFlightNumber = `${flight.id}`

		if (flight.id === FlightStatus.unknown) {
			const currentFlight: IRoute = this.flights[this.flights.length - 1]
			this.isManualFlight = true
			currentFlight.departureTime = ''
			currentFlight.arrivalTime = ''
			currentFlight.manualFlightNumber = ''
		} else {
			const pickedFlight: IFlight = this.flightList.find(e => e.flightNumber === flight.id)!
			const { scheduledDeparture, scheduledArrival } = pickedFlight
			this.isSameDay = date.isSameDate(scheduledDeparture!.slice(0, 10), scheduledArrival!.slice(0, 10))
			this.flights[this.flights.length - 1].isSameDay = this.isSameDay
			this.isManualFlight = false
		}

		this.validatePage()
	}

	private onManualFlightLinkClick (): void {
		this.isManualFlight = true
		this.selectedFlightNumber = FlightStatus.unknown
		this.flights[this.flights.length - 1].departureTime = ''
		this.flights[this.flights.length - 1].arrivalTime = ''
		this.flights[this.flights.length - 1].manualFlightNumber = ''
		this.validatePage()
	}

	private removeFlight (index: number): void {
		this.flights.splice(index, 1)
		this.isFormValid = true

		this.$emit('form-updated', this.isFormValid)

		if (index === 0) {
			this.$emit('reset-connection-flight')
		} else {
			const currentRoute: IRoute = this.flights[this.flights.length - 1]

			this.getFlightList()
				.then(() => {
					const currentFlightData: IFlight = this.flightList.find((el: IFlight) => el.flightNumber === currentRoute.selectedFlightNumber)!
					this.selectedDayPeriodOption = currentRoute.timeRange

					if (typeof currentFlightData !== 'undefined') {
						this.selectedFlightNumber = currentFlightData.flightNumber!
					} else {
						this.selectedFlightNumber = FlightStatus.unknown
						this.isSameDay = currentRoute.isSameDay!
						this.isManualFlight = true
					}

					this.updateFlightListData()
				})
				.catch((e: any) => console.error(e))
		}
	}

	private addFlight (): void {
		const newFlight: IRoute = deepClone<IRoute>(this.emptyFlight)
		const index: number = this.flights.length - 1
		const lastFlight: IRoute = this.flights[index]

		newFlight.depAirport = lastFlight.arrAirport
		newFlight.isSameDay = this.isSameDay

		if (lastFlight.flightStatus === FlightStatus.unknown || lastFlight.flightStatus === FlightStatus.cancelled) {
			newFlight.flightStatus = lastFlight.flightStatus
		}

		this.flights.push(newFlight)
		this.isFormValid = false
		this.isManualFlight = false
		this.flightListData = []
		this.selectedDayPeriodOption = ''
		this.$emit('form-updated', this.isFormValid)
	}

	/**
	 * Retrieves the list of flights from the API by airports, airline and the
	 * date, then data get's transformed to be filtered in DayRangeToggler
	 * and rendered in the RadioList appropriately.
	 */
	private getFlightList (): Promise<any> {
		const currentFlight: IRoute = this.flights[this.flights.length - 1]
		const depIATA: string = currentFlight.depAirport.iata
		const arrIATA: string = currentFlight.arrAirport.iata
		const airports: string = `${depIATA}/${arrIATA}`
		const airline: string = currentFlight.airline.airlineCode
		const date: string = currentFlight.date.convertDateToISOStandart()

		if (airports && airline && date) {
			this.setStatus('pending')
			return FlightService.getFlightListByRouteData(airports, airline, date)
				.then((data: any) => {
					this.flightList = data

					// Updating the flight list data within the DayRangeToggler
					this.updateFlightListData()
					this.setStatus('success')
				})
				.catch((e: any) => this.setStatus('error.flightsNotFetched', e))
		} else {
			return Promise.reject(new Error('Required data such as either airports, airline or date, is not prepared for API call'))
		}
	}

	/**
	 * Updates the RadioList component with new flight data after retrieving the
	 * flight list from backend. At the same time this method validates radio
	 * list options by comparing the date and the time of the previous flight,
	 * and defining whether we should enable or disable flight options that
	 * happened before the previous flight, because such cases are impossible.
	 */
	private updateFlightListData (): void {
		// workaround to get the enum value out of the this.selectedDayPeriodOption
		const selectedDayPeriodOption: any = this.selectedDayPeriodOption
		const enumTimeRange: keyof typeof DayPeriods = selectedDayPeriodOption
		const flightNotFound: IListItem = {
			label: 'flights.notFound',
			id: FlightStatus.unknown
		}
		const filteredFlights: IFlight[] = filterFlightsByTime(this.flightList, DayPeriods[enumTimeRange])
		const prevDateProp: string | undefined = this.prevDate
		const prevTime: string | undefined = this.getPrevTime
		const currentDate: string | undefined = this.flights[this.flights.length - 1].date
		const destinationDate: Date = date.addToDate(new Date(Date.now()), { year: 1 })
		let prevFullDate: string | undefined
		let isSameDate: boolean = false

		if (!!prevDateProp && !!prevTime && this.flights.length === 1) {
			prevFullDate = `${prevDateProp.convertDateToISOStandart()}T${prevTime}:00`
			isSameDate = date.isSameDate(currentDate.convertDateToISOStandart(), prevDateProp.convertDateToISOStandart())
			this.prevDateDoesMatch = isSameDate
		} else if (this.flights.length > 1) {
			const previousFlight: IRoute = this.flights[this.flights.length - 2]
			const prevFlightDate: string = previousFlight.date.convertDateToISOStandart()
			const prevIsSameDay: boolean = previousFlight.isSameDay!
			const prevDate: string = prevIsSameDay ? prevFlightDate : date.addToDate(prevFlightDate, { days: 1 }).extractDate()
			const prevArrTime: string = previousFlight.arrivalTime!
			prevFullDate = `${prevDate}T${prevArrTime}:00`
			isSameDate = date.isSameDate(currentDate.convertDateToISOStandart(), prevDate)
			this.prevDateDoesMatch = isSameDate
		}

		if (filteredFlights.length) {
			this.flightListData = filteredFlights.map((el: IFlight) => {
				return {
					id: el.flightNumber ? el.flightNumber : '',
					label: el.scheduledDeparture ? `${extractTime(el.scheduledDeparture)} - ${el.flightNumber}` : '',
					isDisabled: isSameDate ? !date.isBetweenDates(el.scheduledDeparture!, prevFullDate!, destinationDate) : false
				}
			})
			this.flightListData.push(flightNotFound)
		} else {
			this.flightList = []
			this.flightListData = []
		}
	}

	/**
	 * Made to reset the data, that is dependant from request-sensitive data
	 * So, when customer manipulates with the data that is taking part in API
	 * call, that retrieves the flight list - we need  to reset the previous
	 * progress
	 */
	private resetFlightList (): void {
		this.selectedDayPeriodOption = ''
		this.selectedFlightNumber = ''
		this.isManualFlight = false
		this.flightListData = []
		this.flights[this.flights.length - 1].arrivalTime = ''
	}

	/**
	 * Checks and validates all the custom components for sake of enable/disable
	 * the next button. Additionally it checks if the airports are matching with
	 * each other, and also it sets the values of each field into the array of
	 * flights, that should contain the relevant data when we submit the page
	 * or add another flight.
	 */
	private validatePage (): void {
		const refsData = Object.entries(this.$refs)
		const index: number = this.flights.length - 1
		const isManualFlight: boolean = this.selectedFlightNumber === FlightStatus.unknown
		const depTimeIsInvalid: boolean = this.flights[index].departureTime!.length !== 5
		const arrTimeIsInvalid: boolean = this.flights[index].arrivalTime!.length !== 5
		const manualFlightNumberIsInvalid: boolean = !this.flights[index].manualFlightNumber
		const manuaFlightFormIsInvalid: boolean = isManualFlight && (depTimeIsInvalid && arrTimeIsInvalid && manualFlightNumberIsInvalid)
		let isValid: boolean = true
		let isManualFlightValid: boolean = true

		/**
		 * Explicitly removing manualFlight data manually from refsData to prevent
		 * a bug, when you click on `manual flight` radio button, and then clicking
		 * on a real flight again.
		 * Manual flight number along with arrival and departure time are always
		 * the last element in form refs elements, so we just set the appropriate
		 * length of array to reduce last ref elements from the refsData array
		 */
		if (!isManualFlight) {
			refsData.length = 5
		}

		for (let [key] of refsData) {
			const currentRef: any = this.$refs[key]
			const element: any = currentRef[0]

			this.flights[index].timeRange = this.selectedDayPeriodOption
			this.flights[index].selectedFlightNumber = this.selectedFlightNumber

			// Extracting the model data from each ref component to fulfill the flights
			if (element) {
				this.flights[index][key] = element.modelData
			}
			// Manual validation of the airports along with vuelidate
			if ((element && element.$v.$invalid) || this.flights[index][key].isValid === false) {
				isValid = false
				break
			}
		}

		// Manual flight form contains arrTime depTime and flight number field
		if (manuaFlightFormIsInvalid) {
			isManualFlightValid = false
		}

		/**
		 * As page validation starts  only when the API call is ended, so that we
		 * surely know that this flight is gonna be in the flightList. To make the
		 * form validation pass, we require time field. This is an elegant workaround
		 * for keeping the Timepicker required, in case of the manual flight, and
		 * making it kinda optional, when we picked the flight from flight list.
		 */
		if (!!this.selectedFlightNumber && !isManualFlight) {
			const currentFlight: IFlight = this.flightList.find((el: IFlight) => el.flightNumber === this.selectedFlightNumber)!
			// in some cases actualArrival has null value, so we take scheduled arrival tme as a fallback value to align with
			const arrivalTime: string = !currentFlight.actualArrival ? currentFlight.scheduledArrival! : currentFlight.actualArrival
			this.flights[index].departureTime = extractTime(currentFlight.scheduledDeparture!)
			this.flights[index].arrivalTime = extractTime(arrivalTime)
			isManualFlightValid = true
		}

		this.isFormValid = isValid && isManualFlightValid

		this.isPageValid = this.isFormValid && !!this.selectedDayPeriodOption && !!this.selectedFlightNumber

		this.$emit('form-updated', this.isPageValid)
	}
}
